<template>
  <div class="editor">
    <div class="workbench-body-navbar">
      <div class="workbench-body-navbar-item" @click="undo">
        <Icon type="ios-undo" />
        <span class="navbar-item-name">{{
          $t("message.workBench.body.script.editor.navBar.undo")
        }}</span>
      </div>
      <div class="workbench-body-navbar-item" @click="redo">
        <Icon type="ios-redo" />
        <span class="navbar-item-name">{{
          $t("message.workBench.body.script.editor.navBar.redo")
        }}</span>
      </div>
      <div class="workbench-body-navbar-group">
        <!-- 保存 -->
        <div
          class="workbench-body-navbar-item"
          title="Ctrl+S"
          @click="saveTotal"
        >
          <Icon
            type="md-checkmark"
            :class="script.readOnly ? 'disabled-color' : 'navbar-item-name'"
          />
          <span
            :class="script.readOnly ? 'disabled-color' : 'navbar-item-name'"
            >{{ $t("message.workBench.body.script.editor.navBar.save") }}</span
          >
        </div>
        <!-- 格式化 -->
        <div
          class="workbench-body-navbar-item"
          title="Ctrl+Shift+L"
          @click="setFormat"
        >
          <span class="fi-format" />
          <span class="navbar-item-name">{{
            this.$t("message.monacoMenu.GSH")
          }}</span>
        </div>
        <!--  测试 -->
        <div class="workbench-body-navbar-item" @click="clickTest">
          <Icon type="ios-play" class="navbar-item-name" />
          <span class="navbar-item-name">测试</span>
        </div>
        <!-- 发布 -->
        <div class="workbench-body-navbar-item" @click="setPublish">
          <Icon
            type="ios-send"
            :class="
              script.flowStatus !== -1 ? 'disabled-color' : 'navbar-item-name'
            "
          />
          <span
            :class="
              script.flowStatus !== -1 ? 'disabled-color' : 'navbar-item-name'
            "
            >发布</span
          >
        </div>
        <div>
          <span style="font-size: 9px; color: red"
            >温馨提示：接口QPS建议小于50，超过50稳定性可能会出现问题~</span
          >
        </div>
      </div>
      <div class="workbench-body-navbar-item justifyEnd">
        <Select
          v-model="datasourceId"
          style="width: 350px"
          filterable
          placeholder="请选择要查询的数据源~"
          size="small"
          @on-select="setHot"
        >
          <Option
            v-for="item in dataSourceList"
            :value="item.id"
            :key="item.id"
            >{{ item.name }}</Option
          >
        </Select>
      </div>
    </div>
    <div class="editor-content">
      <we-editor
        ref="editor"
        v-model="script.data"
        :language="script.lang"
        :id="script.id"
        :read-only="script.readOnly"
        :script-type="scriptType"
        :application="script.application"
        type="code"
        @on-operator="heartBeat"
        @on-save="saveTotal"
        @is-parse-success="changeParseSuccess"
      />
      <testApi-com
        ref="customApiSetting"
        v-if="showApiParam"
        :url="script.params.define.url"
        :method="script.params.define.method"
        :paramList="script.params.inputParameters"
        @getApiAction="apiTestAction"
      />
    </div>
  </div>
</template>
<script>
import TestApi from "./testApi.vue";
import api from "@dss/js/service/api";
import storage from "@dss/js/helper/storage";
import { throttle } from "lodash";
import axios from "axios";
import { requestWithSign, ROOT_SERVER } from "@/api";

export default {
  components: {
    "testApi-com": TestApi,
  },
  props: {
    script: {
      type: Object,
      required: true,
    },
    work: {
      type: Object,
      required: true,
    },
    scriptType: {
      type: String,
      default: "workspaceScript",
    },
  },
  data() {
    return {
      loading: false,
      isParseSuccess: true,
      datasourceId: "",
      dataSourceList: [],
      showApiParam: false, //是否展示测试
      apiticket: {
        time: "",
        value: "",
      },
    };
  },
  mounted() {
    this.getDataSourceList();
    this.datasourceId = this.script.params.define.datasourceId;
    this.$emit("getValideSQLFn", this.checkSql);
  },
  methods: {
    getDataSourceList() {
      axios
        .get(`/api/rest_j/v1/metadata/v1/getDBSourceInfoforapi`)
        .then((res) => {
          if (!res.data || !Array.isArray(res.data) || res.data.length <= 0) {
            this.$Message.warning("没有数据源可供选择");
          }
          let filterType = [
            "mysql",
            "rds",
            "clickhouse",
            "gp",
            "redis",
            "hbase",
          ]; //允许展示的数据类型
          res.data = res.data.filter((item) => {
            if (filterType.includes(item.type)) {
              return item;
            }
          });
          this.dataSourceList = res.data.map((item) => ({
            id: item.sourceId,
            name: item.sourceName,
            type: item.type,
          }));
          if (!this.datasourceId) {
            this.datasourceId = this.dataSourceList[0].id;
            this.$emit("getSourceId", this.datasourceId);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    async getTicket(cb) {
      let apiticket = this.apiticket;
      let overdue = false;
      if (apiticket.time) {
        try {
          overdue =
            (new Date().getTime() - apiticket.time) / 1000 / 60 > 5
              ? true
              : false;
        } catch (err) {
          console.log(err);
        }
      }
      // //凭证不存在或者url改变或者凭证超过五分钟需先获取测试凭证
      if (!apiticket.value || overdue) {
        let { data, retCode, msg } = await requestWithSign({
          method: "POST",
          url: `${ROOT_SERVER}/data-api-development-rest/test/ticket`,
          data:
            this.script.flowStatus === 1
              ? this.script.id - 0
              : this.script.copy,
          token: storage.get("access-user-token", "cookie"),
        }).catch((err) => {
          cb(false);
          console.log(err);
        });
        if (retCode === "00000") {
          this.apiticket = {
            time: new Date().getTime(),
            value: data,
          };
          cb(data);
        } else {
          cb(false);
        }
      } else {
        cb(apiticket.value);
      }
    },
    "Workbench:insertValue"(args) {
      if (args.id === this.script.id) {
        this.$refs.editor.insertValueIntoEditor(args.value);
      }
    },
    "Workbench:setParseAction"(id) {
      if (id === this.script.id) {
        const editor = this.$refs.editor;
        if (editor) {
          const isParserClose = !!storage.get("isParserClose", "local");
          editor.isParserClose = isParserClose;
          editor.closeParser && editor.closeParser.set(!isParserClose);
          editor.openParser && editor.openParser.set(isParserClose);
        }
      }
    },
    undo() {
      this.$refs.editor.undo();
    },
    redo() {
      this.$refs.editor.redo();
    },

    // 关闭api服务测试
    apiTestAction(obj) {
      if (obj) {
        this.$emit("getResult", obj);
      }
      this.showApiParam = false;
    },
    heartBeat: throttle(() => {
      api.fetch("/user/heartbeat", "get");
    }, 60000),
    changeParseSuccess(flag) {
      this.isParseSuccess = flag;
    },
    setHot(rest) {
      this.$emit("getSourceId", rest.value);
    },
    async checkSql(cb, format) {
      let selectCode = this.script.data || this.$refs.editor.getValueInRange();
      if (!selectCode) {
        this.$Message.warning("脚本内容不能为空");
        cb && cb(false);
        return;
      }
      if (this.script.validateSQL !== selectCode || format) {
        let { data, retCode, retInfo } = await this.handleValidateSQL(
          selectCode
        ); //验证sql
        if (retCode === "00000") {
          let { inputParameterNames, outputParameterNames, script: sql } = data;
          let inputParameters = [],
            outputParameters = [];
          inputParameterNames.forEach((item) => {
            inputParameters.push({
              name: item,
              type: "string",
              desc: "",
              example: "",
              defaultValue: "",
            });
          });
          outputParameterNames.forEach((item) => {
            outputParameters.push({
              name: item,
              type: "string",
              desc: "",
            });
          });
          // this.$emit("getinpoutParams", { inputParameters, outputParameters });
          this.script.validateSQL = selectCode;
          this.script.params.inputParameters.forEach((item, i) => {
            let index = inputParameters.findIndex(
              (subItem) => item.name == subItem.name
            );
            if (index >= 0) {
              inputParameters[index] = this.script.params.inputParameters[i];
            }
          });
          this.script.params.inputParameters = inputParameters;

          this.script.params.outputParameters.forEach((item, i) => {
            let index = outputParameters.findIndex(
              (subItem) => item.name == subItem.name
            );
            if (index >= 0) {
              outputParameters[index] = this.script.params.outputParameters[i];
            }
          });
          this.script.params.outputParameters = outputParameters;

          cb && cb(sql);
        } else {
          cb && cb(false);
          this.$Message.error(retInfo);
          return;
        }
      } else {
        cb && cb(true);
      }
    },
    async handleValidateSQL(script) {
      return await requestWithSign({
        method: "POST",
        url: `${ROOT_SERVER}/data-api-development-rest/api/validateScript`,
        data: {
          script,
          dataSourceId: this.datasourceId,
        },
        token: storage.get("access-user-token", "cookie"),
      }).catch((err) => {
        this.$Message.error(err.message);
      });
    },
    async saveTotal(cb) {
      if (this.script.readOnly) {
        return;
      }
      this.checkSql((status) => {
        if (status) {
          this.$emit("on-save", (status) => {
            if (typeof cb === "function") {
              cb(status);
            }
          });
        }
      });
    },
    clickTest() {
      if (!this.script.readOnly) {
        this.saveTotal(this.testSave);
      } else {
        this.showApiParam = true;
      }
    },
    testSave(status) {
      if (status) {
        this.showApiParam = true;
      }
    },
    async setPublish() {
      if (this.script.flowStatus !== -1) {
        return;
      }
      this.$Modal.confirm({
        title: "上线",
        content: "确定提交上线申请吗？",
        loading: true,
        onOk: () => {
          this.dispatch("Workbench:onLine", this.script);
          setTimeout(() => {
            this.$Modal.remove();
          });
        },
      });
    },
    setFormat() {
      this.checkSql((sql) => {
        if (sql) {
          this.script.data = sql;
          this.script.validateSQL = sql;
        }
      }, true);
    },
  },
};
</script>
<style scoped>
.workbench-body-navbar-item .disabled-color {
  color: #ccc;
  cursor: not-allowed;
}
</style>
